import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "editButton", "saveButton", "cancelButton"]

  connect() {
    this.savedValue = this.inputTarget.value
  }

  edit() {
    this.toggle(true)
    this.inputTarget.focus()
    const length = this.inputTarget.value.length
    this.inputTarget.setSelectionRange(length, length)
  }

  cancel() {
    this.inputTarget.value = this.savedValue
    this.toggle(false)
  }

  lock(event) {
    if (event.detail.success) {
      this.savedValue = this.inputTarget.value
      this.toggle(false)
    }
  }

  toggle(editing) {
    this.inputTarget.readOnly = !editing
    this.inputTarget.classList.toggle("bg-gray-50", !editing)
    this.inputTarget.classList.toggle("border-transparent", !editing)
    this.inputTarget.classList.toggle("pointer-events-none", !editing)
    this.inputTarget.classList.toggle("focus:border-transparent", !editing)
    this.inputTarget.classList.toggle("focus:ring-0", !editing)
    this.inputTarget.classList.toggle("bg-white", editing)
    this.inputTarget.classList.toggle("border-gray-300", editing)
    this.editButtonTarget.classList.toggle("hidden", editing)
    this.saveButtonTarget.classList.toggle("hidden", !editing)
    this.cancelButtonTarget.classList.toggle("hidden", !editing)
  }
}
